// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_k5-0";
export var fulfillmentPanelBody = "_k5-1";